import { useParams } from "react-router-dom";

export default function Business() {
  const { type } = useParams();
  let content;

  switch (type) {
    case 'automatic-driving':
      content =
        <>
          <div className="top__banner top2">
            <div className="tb__text">
              <h1>사업영역</h1>
              <h2>BUSINESS</h2>
            </div>
          </div>
          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업영역</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">자율주행 인터페이스 제작</span>
                    <div className="snav">
                      <ul>
                        <li><a href="/business/semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                        <li><a href="/business/automation"><span>자동화장비 제작</span></a></li>
                        <li><a href="/business/mobility"><span>모빌리티 제작</span></a></li>
                        <li className="on"><a href="/business/automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = '/business/semiconductor')}>사업영역</span>
                  <span className="arrow"></span>
                  <span>자율주행 인터페이스 제작</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner2_4.jpg" alt="" />

                    <div className="sb__text">
                      <h3>자율주행 인터페이스 제작</h3>
                    </div>
                  </div>

                  <div className="mobility">
                    <div className="business">
                      <div className="subject">
                        <div>자율주행 인터페이스</div>
                      </div>

                      <div className="bs__img one">
                        <img src="../img/business/2_4_pic1.jpg" alt="" />
                      </div>

                      <div className="bs__desc one">
                        <p className="pc">일반 차량을 자율주행 차량으로 개조할 경우에 액추에이터 및 차량과의 통신을 통해 차량을 제어하기 위한 모듈입니다.</p>
                        <p className="pc">차종별로 의뢰를 받아 제작되며, 요청사항에 맞추어 제작되는 인터페이스 모듈입니다.</p>
                        <p className="pc">차량과 인지/판단하는 PC와의 중간 컨트롤을 위한 장치이며, 자율주행 차량의 개조 시에 꼭 필요한 장치입니다.</p>

                        <p className="mo">
                          일반 차량을 자율주행 차량으로 개조할 경우에 액추에이터 및 차량과의 통신을 통해 차량을 제어하기 위한 모듈입니다.
                          차종별로 의뢰를 받아 제작되며, 요청사항에 맞추어 제작되는 인터페이스 모듈입니다.
                          차량과 인지/판단하는 PC와의 중간 컨트롤을 위한 장치이며, 자율주행 차량의 개조 시에 꼭 필요한 장치입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      break;
    case 'automation':
      content =
        <>
          <div className="top__banner top2">
            <div className="tb__text">
              <h1>사업영역</h1>
              <h2>BUSINESS</h2>
            </div>
          </div>
          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업영역</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">자동화장비 제작</span>
                    <div className="snav">
                      <ul>
                        <li><a href="semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                        <li className="on"><a href="automation"><span>자동화장비 제작</span></a></li>
                        <li><a href="mobility"><span>모빌리티 제작</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'semiconductor')}>사업영역</span>
                  <span className="arrow"></span>
                  <span>자동화장비 제작</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner2_2.jpg" alt="" />

                    <div className="sb__text">
                      <h3>자동화장비 제작</h3>
                    </div>
                  </div>

                  <div className="autoeq">
                    <div className="business">
                      <div className="subject">
                        <div>배관 자동화 용접기</div>
                      </div>

                      <div className="bs__img one">
                        <img src="../img/business/2_2_pic1.jpg" alt="" />
                      </div>

                      <div className="bs__desc one">
                        <p className="pc">파이프에 궤도를 장착하여 궤도를 주행하며 파이프를 용접할 수 있는 장치를 개발하였습니다.</p>
                        <p className="pc">추가적으로 자율주행 개발 시에 사용했던 비전 센서(카메라)를 장착하였습니다.</p>
                        <p className="pc">일반적인 자동화 용접기는 용접사가 컨트롤러를 이용해 용접 부위를 직접 보고 용접하지만 카메라를 이용하여</p>
                        <p className="pc">원거리에서도 조정이 가능하도록 제작되었습니다.</p>
                        <p className="pc">실시간 용접 영상을 보고 용접을 하며 용접 시 수집된 영상 데이터는 저장 및 각종 파라메터의 저장이 가능하며</p>
                        <p className="pc">다시 용접 데이터를 확인하거나 다른 시스템으로 공유가 가능한 것이 장점입니다.</p>
                        <p className="pc">컨트롤 프로그램 또한 A SPEC에서 직접 제작 하였으며,</p>
                        <p className="pc">자동화 용접기의 영상 확인 및 원거리 조정이 가능하도록 되어있습니다.</p>

                        <p className="mo">
                          파이프에 궤도를 장착하여 궤도를 주행하며 파이프를 용접할 수 있는 장치를 개발하였습니다.
                          추가적으로 자율주행 개발 시에 사용했던 비전 센서(카메라)를 장착하였습니다.
                          일반적인 자동화 용접기는 용접사가 컨트롤러를 이용해 용접 부위를 직접 보고 용접하지만 카메라를 이용하여
                          원거리에서도 조정이 가능하도록 제작되었습니다.
                          실시간 용접 영상을 보고 용접을 하며 용접 시 수집된 영상 데이터는 저장 및 각종 파라메터의 저장이 가능하며
                          다시 용접 데이터를 확인하거나 다른 시스템으로 공유가 가능한 것이 장점입니다.
                          컨트롤 프로그램 또한 A SPEC에서 직접 제작 하였으며,
                          자동화 용접기의 영상 확인 및 원거리 조정이 가능하도록 되어있습니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      break;
    case 'mobility':
      content =
        <>

          <div className="top__banner top2">
            <div className="tb__text">
              <h1>사업영역</h1>
              <h2>BUSINESS</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업영역</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">모빌리티 제작</span>
                    <div className="snav">
                      <ul>
                        <li><a href="semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                        <li><a href="automation"><span>자동화장비 제작</span></a></li>
                        <li className="on"><a href="mobility"><span>모빌리티 제작</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')}className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'semiconductor')}>사업영역</span>
                  <span className="arrow"></span>
                  <span>모빌리티 제작</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner2_3.jpg" alt="" />

                    <div className="sb__text">
                      <h3>모빌리티 제작</h3>
                    </div>
                  </div>

                  <div className="mobility">
                    <div className="business">
                      <div className="subject">
                        <div>자율주행 플랫폼 차량</div>
                      </div>

                      <div className="bs__img one">
                        <img src="../img/business/2_3_pic1.jpg" alt="" />
                      </div>

                      <div className="bs__desc one">
                        <p className="pc">에이스펙은 차량 조작을 위한 통신, 모터 제어, 액추에이터 제어 기술을 지속적으로 연구/개발해 왔으며,</p>
                        <p className="pc">지속적인 연구/개발을 통해 자체적으로 자율주행 플랫폼 차량을 제작하게 되었습니다.</p>
                        <p className="pc">위 차량은 프로젝트명 CP1으로써 설계부터 제작까지의 모든 부분을 자사의 기술로 제작하였습니다.</p>
                        <p className="pc">전기 모터로 구동되며, 전동식 파워 스티어링을 사용한 자율주행 개발용 플랫폼 및 자율주행 산업용 플랫폼으로써,</p>
                        <p className="pc">차량 상단에 짐을 운반하는 카고, 신선 물품 배송을 위한 냉장탑, 냉동탑, 윙바디, 청소 차량용 진공 탱크 등의</p>
                        <p className="pc">무한한 변신 가능성을 가지고 있어, 다목적 용도로 이용이 가능합니다.</p>

                        <p className="mo">
                          에이스펙은 차량 조작을 위한 통신, 모터 제어, 액추에이터 제어 기술을 지속적으로 연구/개발해 왔으며,
                          지속적인 연구/개발을 통해 자체적으로 자율주행 플랫폼 차량을 제작하게 되었습니다.
                          위 차량은 프로젝트명 CP1으로써 설계부터 제작까지의 모든 부분을 자사의 기술로 제작하였습니다.
                          전기 모터로 구동되며, 전동식 파워 스티어링을 사용한 자율주행 개발용 플랫폼 및 자율주행 산업용 플랫폼으로써,
                          차량 상단에 짐을 운반하는 카고, 신선 물품 배송을 위한 냉장탑, 냉동탑, 윙바디, 청소 차량용 진공 탱크 등의
                          무한한 변신 가능성을 가지고 있어, 다목적 용도로 이용이 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>
      break;
    case 'semiconductor':
      content =
        <>

          <div className="top__banner top2">
            <div className="tb__text">
              <h1>사업영역</h1>
              <h2>BUSINESS</h2>
            </div>
          </div>

          <div className="nav__wrap">
            <div className="nav__container">
              <div className="nav">
                <div className="mnav">
                  <div className="depth depth1">
                    <span className="">사업영역</span>
                  </div>
                  <div className="depth depth2">
                    <span className="">반도체 플랜트 배관 및 랙 제작</span>
                    <div className="snav">
                      <ul>
                        <li className="on"><a href="semiconductor"><span>반도체 플랜트 배관 및 랙 제작</span></a></li>
                        <li><a href="automation"><span>자동화장비 제작</span></a></li>
                        <li><a href="mobility"><span>모빌리티 제작</span></a></li>
                        <li><a href="automatic-driving"><span>자율주행 인터페이스 제작</span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="loc">
                  <img src="../img/ico/home_icon.png" alt="home" onClick={() => (window.location.href = '/')} className="menuPathBtn" />
                  <span className="arrow"></span>
                  <span className="menuPathBtn" onClick={() => (window.location.href = 'semiconductor')}>사업영역</span>
                  <span className="arrow"></span>
                  <span>반도체 플랜트 배관 및 랙 제작</span>
                </div>
              </div>
            </div>
          </div>

          <section>
            <div className="container-1400">
              <div className="contents">
                <div className="content">
                  <div className="sbanner sbanner1">
                    <img src="../img/banner/sbanner2_1.jpg" alt="" />

                    <div className="sb__text">
                      <div>
                        <p>반도체 플랜트의 핵심인</p>
                        <h3>배관 및 랙 제작 사업</h3>
                      </div>
                    </div>
                  </div>

                  <div className="semi">
                    <div className="business">
                      <div className="subject num">
                        <div><span>01</span>플랜트 배관 제작</div>
                      </div>

                      <div className="bs__img two">
                        <img src="../img/business/2_1_pic1.jpg" alt="" />
                        <img src="../img/business/2_1_pic2.jpg" alt="" />
                      </div>

                      <div className="bs__desc">
                        <p className="pc">플랜트 배관 설계 단계에서 요구 사항 파악 후 각 공정마다 들어가는 가스, 부동액, 압축공기 라인 등 크기에 맞춰</p>
                        <p className="pc">절단, 가공, 용접, 도장, 조립을 거쳐 시스템을 완성하고, 정밀한 품질 검사를 통해 규정에 부합되는지 확인 후 현장 반입됩니다.</p>

                        <p className="mo">
                          플랜트 배관 설계 단계에서 요구 사항 파악 후 각 공정마다 들어가는 가스, 부동액, 압축공기 라인 등 크기에 맞춰
                          절단, 가공, 용접, 도장, 조립을 거쳐 시스템을 완성하고, 정밀한 품질 검사를 통해 규정에 부합되는지 확인 후 현장 반입됩니다.
                        </p>
                      </div>
                    </div>

                    <div className="business">
                      <div className="subject num">
                        <div><span>02</span>플랜트 랙 제작</div>
                      </div>

                      <div className="bs__img two">
                        <img src="../img/business/2_1_pic3.jpg" alt="" />
                        <img src="../img/business/2_1_pic4.jpg" alt="" />
                      </div>

                      <div className="bs__desc">
                        <p className="pc">반도체 제조 시설에서 사용되는 시스템을 구축하기 위한 철골 프레임으로 배관 탑재, 유지보수를 위해 정확한 설계와 가공,</p>
                        <p className="pc">취부, 용접, 사상 도장, 조립하는 과정을 거쳐 거대한 지지대를 완성하는 단계로 품질검사를 통해 안전하고 정밀한 시스템을 구축합니다.</p>

                        <p className="mo">
                          반도체 제조 시설에서 사용되는 시스템을 구축하기 위한 철골 프레임으로 배관 탑재, 유지보수를 위해 정확한 설계와 가공,
                          취부, 용접, 사상 도장, 조립하는 과정을 거쳐 거대한 지지대를 완성하는 단계로 품질검사를 통해 안전하고 정밀한 시스템을 구축합니다.
                        </p>
                      </div>
                    </div>

                    <div className="business">
                      <div className="subject num">
                        <div><span>03</span>플랜트 배관 및 모듈 조립</div>
                      </div>

                      <div className="bs__img two">
                        <img src="../img/business/2_1_pic5.jpg" alt="" />
                        <img src="../img/business/2_1_pic6.jpg" alt="" />
                      </div>

                      <div className="bs__desc">
                        <p className="pc">제작된 랙을 조립 후 위치에 맞게 배관, 덕트 등을 설치하고 현장 입고 후 구역별로 조립된 81개의 모듈이 조립되어</p>
                        <p className="pc">하나의 메가 모듈로 제작되어 효율적인 생산성 향상을 목적을 가지고, 이러한 과정을 거쳐 반도체 제조 시설의 기반 구조가 완성됩니다.</p>

                        <p className="mo">
                          제작된 랙을 조립 후 위치에 맞게 배관, 덕트 등을 설치하고 현장 입고 후 구역별로 조립된 81개의 모듈이 조립되어
                          하나의 메가 모듈로 제작되어 효율적인 생산성 향상을 목적을 가지고, 이러한 과정을 거쳐 반도체 제조 시설의 기반 구조가 완성됩니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>

      break;
    default:
      content = <h1>404 Not Found</h1>;
  }

  return (
    <>
      {content}
    </>
  );
}